// Reusable 4x6 Thrive carton/pallet GS1-128 SSCC label (CARTON|PALLET state); mapped identity.
// Generated by scripts/wms/generate.ts for PHP-412. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomThriveSsccLabelFileDataSchema = yup.object().shape({
  customerDisplayName: yup.string().nullable().optional(),
  shipFromAddress: yup.string().nullable().optional(),
  thriveLocation: yup.string().nullable().optional(),
  shipToAddress: yup.string().nullable().optional(),
  postalCode: yup.string().nullable().optional(),
  postalBarcode: yup.string().nullable().optional(),
  carrier: yup.string().nullable().optional(),
  bolNumber: yup.string().nullable().optional(),
  proNumber: yup.string().nullable().optional(),
  packageType: yup.string().nullable().optional(),
  cartonSequence: yup.string().nullable().optional(),
  cartonCount: yup.string().nullable().optional(),
  palletSequence: yup.string().nullable().optional(),
  palletCount: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  multipleSku: yup.string().nullable().optional(),
  itemNumber: yup.string().nullable().optional(),
  itemDescription: yup.string().nullable().optional(),
  lotCode: yup.string().nullable().optional(),
  expDate: yup.string().nullable().optional(),
  cases: yup.string().nullable().optional(),
  sscc: yup.string().nullable().optional(),
  ssccBarcode: yup.string().nullable().optional(),
})

export type BiomThriveSsccLabelFileData = yup.InferType<typeof biomThriveSsccLabelFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<BiomThriveSsccLabelFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomThriveSsccLabelFileMappings: RequiredFileData = {
  customerDisplayName: 'f9517f11-00b6-4c21-9924-9a66a7f12a95',
  shipFromAddress: '15e80205-1692-49c5-a05c-dc8180284537',
  thriveLocation: '751cc02d-fb52-451d-8867-5a13a49cbebf',
  shipToAddress: '570de0f3-4bca-4a77-b4ba-16b71d4d91dd',
  postalCode: '3b65534b-0436-4954-be6d-b7dcbaef876b',
  postalBarcode: 'ec47aefd-23c4-4f1a-a2f4-a415692162ef',
  carrier: '988020a9-af57-4497-a116-c10384a8bfc0',
  bolNumber: 'e8f445d2-2010-4fe9-b8c6-63f968f7cd5e',
  proNumber: '34f3e729-519f-4024-ac61-71791bd74c7f',
  packageType: 'a97223a3-8398-4159-a262-018d21b9c7d6',
  cartonSequence: '20f6a8ef-c268-4a0e-8e2c-5fce2803fc3e',
  cartonCount: '55858c7e-0e45-4d02-b9c4-874ec9d30708',
  palletSequence: '98c94ffe-f62e-47ef-8c06-c412faa17c8b',
  palletCount: 'cc939714-4375-4dfc-9f2d-5ad842b8c852',
  poNumber: '97a9f8b4-ddb6-4ff3-bec1-0e22fe8dd824',
  multipleSku: '4a6f0e3e-590d-44cd-9868-e7798343ee8c',
  itemNumber: '05424816-a919-414a-a8ab-33c251775aac',
  itemDescription: '890af8dd-3140-49a6-9a74-96bece2f73c0',
  lotCode: 'd6f19c0c-12f3-4e66-b77a-8d41171c2296',
  expDate: '505479f4-40a9-400e-a9b5-0eb1f719a897',
  cases: '944b65a6-9d76-4408-9092-bb45d844319e',
  sscc: '33cc6e67-4f62-4a39-84b3-ec2ce71a8f70',
  ssccBarcode: 'ce68d57d-e1b3-49a3-bd67-236329f5ac1c',
}
